import { IOneViewPermissions } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/one-view-permissions.interface';
import { OneViewPermissionsAction } from './one-view-permissions.action';

export interface OneViewPermissionsState {
  permissions: IOneViewPermissions | null;
  pending: boolean;
  isLoaded: boolean;
  error: string | null;
}

export const initialState: OneViewPermissionsState = {
  permissions: null,
  pending: false,
  isLoaded: false,
  error: null,
};

export function OneViewPermissionsReducer(
  state: OneViewPermissionsState = initialState,
  action?: OneViewPermissionsAction,
): OneViewPermissionsState {
  switch (action.type) {
    case OneViewPermissionsAction.getOneViewPermissions:
      return {
        ...state,
        pending: true,
      };

    case OneViewPermissionsAction.getOneViewPermissionsSuccess:
      return {
        ...state,
        permissions: (action.payload as IOneViewPermissions) || null,
        pending: false,
        isLoaded: true,
        error: null,
      };

    case OneViewPermissionsAction.getOneViewPermissionsError:
      return {
        ...state,
        pending: false,
        isLoaded: true,
        error: action.payload,
      };

    default:
      return state;
  }
}
